import { Attachment } from 'portal2-models'
import { AttachmentType } from 'portal2-frontend'
import { errorHandlerCallback, userDataRefreshCallback } from './index'
import { wrappedFetch as fetch } from './wrappedFetch'

export const downloadApplicationAttachment = async (attachmentId: number) => {
	try {
		const response = await fetch(`/api/applications/attachment/${attachmentId}`)
		const blob = await response.blob() 
		return blob
	}
	catch (err) {
		errorHandlerCallback ? errorHandlerCallback(err) : console.error("Failed to retrieve attachment from server")
	}
}

const AttachmentApiPath: Record<AttachmentType, string> = {
	Application: '/api/applications/attachment',
	EftForm: '/api/claims/EftForm',
	EftFormBankInfo: '/api/claims/EftFormBankInfo',
	SupportingDocument: '/api/claims/SupportingDocument'
}

const uploadAttachment = async (attachmentType: AttachmentType, parentId: number, file: File) => {
	let response: Response

	try {
		const formData = new FormData()
		formData.append('file', file)

		const path = AttachmentApiPath[attachmentType]
		response = await fetch(`${path}/upload/${parentId}`, {
			method: 'POST',
			body: formData,
		})

		const attachment = await response.clone().json() as Attachment

		userDataRefreshCallback && await userDataRefreshCallback()

		return attachment
	}
	catch (err) {
		// This is pretty ugly.  TODO: fix/combine/streamline this.
		try {
			const invalidFileType = "Invalid FileType";
			const errorText = await response.text()
			if (errorText.includes(invalidFileType)) {
				const fileTypeError = new Error(invalidFileType)
				errorHandlerCallback ? errorHandlerCallback(fileTypeError) : console.error(invalidFileType)
			}
			else {
				const moreInfoError = new Error(err)
				moreInfoError.message = errorText + "\n" + moreInfoError.message 
				errorHandlerCallback ? errorHandlerCallback(moreInfoError) : console.error("Failed to upload attachment to server")
			}
		}
		catch {
			errorHandlerCallback ? errorHandlerCallback(err) : console.error("Failed to upload attachment to server")
		}
	}
}

export const getAttachmentUploader = (attachmentType: AttachmentType) => 
	async (parentId: number, file: File) => uploadAttachment(attachmentType, parentId, file)

const deleteAttachment = async (attachmentType: AttachmentType, attachmentId: number) => {
	try {
		const path = AttachmentApiPath[attachmentType]
		const response = await fetch(`${path}/delete/${attachmentId}`, {
			method: 'POST',
			headers: {'Content-Type': 'application/json'}
		})

		if (response.ok) {
			userDataRefreshCallback && await userDataRefreshCallback()
		}
	}
	catch (err) {
		errorHandlerCallback ? errorHandlerCallback(err) : console.error("Failed to delete attachment at server")
	}
}

export const getAttachmentDeleter = (attachmentType: AttachmentType) =>
	async (attachmentId: number) => deleteAttachment(attachmentType, attachmentId)
